import React, { Component, Fragment } from 'react'
import { DateRangePicker } from 'react-date-range'
import * as rdrLocales from 'react-date-range/dist/locale'
import { ButtonContained } from '../app-button/button'
import Spinner from '../spinner'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import './m-dateRange.css'

class MDateRangePicker extends Component {
  state = {
    locale: rdrLocales.ru,
    startDate: new Date(this.props.startDate),
    endDate: new Date(this.props.endDate),
  }

  handleSelectRange = ranges => {
    this.setState(
      {
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
      },
      () => {
        this.props.getRange(this.state.startDate, this.state.endDate)
      }
    )
  }

  render() {
    const { locale, startDate, endDate } = this.state
    const selectionRange = {
      startDate: startDate,
      endDate: endDate,
      key: 'selection',
    }

    return (
      <Fragment>
        <DateRangePicker
          maxDate={new Date()}
          locale={locale}
          months={2}
          staticRanges={[]}
          direction="horizontal"
          ranges={[selectionRange]}
          onChange={this.handleSelectRange}
          inputRanges={[]}
          showMonthAndYearPickers={false}
          showDateDisplay={false}
          rangeColors={['#8866ff']}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '0 14px 8px 0',
          }}
        >
          <button
            className="rangeCancelBtn"
            onClick={() => this.props.toggleRange()}
          >
            Отмена
          </button>

          <ButtonContained
            style={{ width: 130, fontSize: 13, height: 36, padding: 0 }}
            color="secondary"
            text={
              this.props.isFetching ? (
                <Spinner stroke="#ffffff" width={24} height={24} />
              ) : (
                `Применить`
              )
            }
            onClick={() =>
              this.props.getDashboardWithPeriod(
                this.state.startDate,
                this.state.endDate
              )
            }
          />
        </div>
      </Fragment>
    )
  }
}

export default MDateRangePicker
